import { render, staticRenderFns } from "./listHavoblogComments.vue?vue&type=template&id=6b5e82d2&"
import script from "./listHavoblogComments.vue?vue&type=script&lang=js&"
export * from "./listHavoblogComments.vue?vue&type=script&lang=js&"
import style0 from "./listHavoblogComments.vue?vue&type=style&index=0&id=6b5e82d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports